
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Neuer Kunde</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>Füllen Sie bitte alle Felder aus, um einen neuen Kunden hinzuzufügen.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-text>
                          Neuer Kunde
                          <h3 class="headline">Bitte füllen Sie alle Felder aus</h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Name"
                            outlined
                            label="Name"
                            v-model="customer.name"
                          ></v-text-field>

                          <v-text-field
                            placeholder="E-Mail"
                            outlined
                            label="E-Mail Adresse"
                            v-model="customer.email"
                          ></v-text-field>

                          <v-text-field
                            placeholder="Telefonnummer"
                            outlined
                            label="Telefonnummer"
                            v-model="customer.phone"
                          ></v-text-field>

                          <v-text-field
                            placeholder="Straße"
                            outlined
                            label="Straße"
                            v-model="customer.street"
                          ></v-text-field>

                          <v-text-field
                            placeholder="Hausnummer"
                            outlined
                            label="Hausnummer"
                            v-model="customer.housenumber"
                          ></v-text-field>

                          <v-text-field
                            placeholder="PLZ"
                            outlined
                            label="PLZ"
                            v-model="customer.zip"
                          ></v-text-field>

                          <v-text-field
                            placeholder="Stadt"
                            outlined
                            label="Stadt"
                            v-model="customer.city"
                          ></v-text-field>
                        </v-card-text>

                        <v-card-actions class="justify-center">
                          <v-btn large color="primary" @click="create">Speichern</v-btn>

                          <v-btn large color="error" @click="deleteDialog = true">Löschen</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Kunde Löschen</v-card-title>

        <v-card-text>
          Möchten Sie diesen Kunden wirklich löschen?
          <br />Dazugehörige Nutzer werden ebenfalls gelöscht.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="deleteDialog = false; deleteCustomer()"
          >Ja, Ich möchte den Kunden löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import CustomersSerivce from "@/services/CustomerService";
import AppListItem from "@/views/apps/components/AppListItem";
import AddNewApp from "@/views/apps/components/AddNewApp";
import ColorField from "@/views/general/components/ColorPicker";

export default {
  name: "dashboard",
  components: {
    Header: Header,
    AppListItem: AppListItem,
    AddNewApp: AddNewApp,
    "v-color-field": ColorField
  },
  data: () => ({
    loading: true,
    error: null,
    deleteDialog: false,
    customers: null,
    customer: {
      appId: null,
      name: null,
      street: null,
      housenumber: null,
      zip: null,
      city: null,
      phone: null,
      email: null
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async create() {
      try {
        this.loading = true;

        //add user
        try {
          let payload = this.customer;
          let response = await CustomersSerivce.update(
            this.$route.params.appId,
            this.$route.params.id,
            payload
          );
        } catch (err) {
          alert(err.message);
        }

        this.loading = false;
        router.push({
          name: "Customers",
          params: { id: this.$route.params.appId }
        });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },

    async deleteCustomer() {
      try {
        this.loading = true;

        //add user
        try {
          let response = await CustomersSerivce.delete(
            this.$route.params.appId,
            this.$route.params.id
          );
        } catch (err) {
          alert(err.message);
        }
        this.loading = false;
        router.push({
          name: "Customers",
          params: { id: this.$route.params.appId }
        });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        this.customer = (
          await CustomersSerivce.getCustomer(
            this.$route.params.appId,
            this.$route.params.id
          )
        ).data;

        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

